import {
    getCoreApiUrl,
    ResidentialUnitCustomFieldDto,
    ResidentialUnitCustomFieldTypeDto,
} from '@ygtechnologies/bygr-frontend-component-library';
import { request } from '@/utils/ajax';

export function getUnitVariableTypes(projectId: number): Promise<ResidentialUnitCustomFieldTypeDto[]> {
    return request(getCoreApiUrl() + `/v1/project/${projectId}/unit-variable-types`).then((x) => x.json());
}

export function saveUnitVariableTypes(
    projectId: number | string,
    unitVariables: ResidentialUnitCustomFieldTypeDto[]
): Promise<ResidentialUnitCustomFieldTypeDto[]> {
    return request(getCoreApiUrl() + `/v1/project/${projectId}/unit-variable-types`, {
        method: 'PUT',
        json: true,
        body: { unitVariables },
    }).then((x) => x.json());
}

export function getUnitVariables(projectId: number, unitId: number): Promise<ResidentialUnitCustomFieldDto[]> {
    return request(getCoreApiUrl() + `/v1/project/${projectId}/unit-variable/${unitId}`).then((x) => x.json());
}

export interface UpdateResidentialUnitCustomFieldDto {
    value: string | null;
    residentialUnitCustomFieldTypeId: number;
}

export function updateUnitVariables(
    projectId: number,
    unitId: number,
    variables: Partial<UpdateResidentialUnitCustomFieldDto[]>
) {
    return request(getCoreApiUrl() + `/v1/project/${projectId}/unit-variable/${unitId}`, {
        method: 'PUT',
        json: true,
        body: variables,
    });
}
